function NRArrowForwardIcon({ height = '24', width = '24', color = 'currentColor' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <g id="arrow_forward_icon">
        <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill={color} />
      </g>
    </svg>
  );
}

export default NRArrowForwardIcon;
